app.controller('BrowseProductMatrixController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    let initialized = false;
    const isComponentMatrix = !!$scope.is_component_matrix;

    $scope.is_admin_matrix = isComponentMatrix && $rootScope.service.account.isMasterAdmin(true);

    const modelConstructor = $rootScope.model_constructor;
    const FilterConditionModel = modelConstructor.extend(modelConstructor.BasicModel,
        {
            quick_value: "any"
        })
    const siteHelper = $rootScope.site_helper;
    const ModelChoice = modelConstructor.ModelChoice;

    const navigationIDs = $scope.navigation_ids;

    $scope.matrix_product_model = $rootScope.factory.matrix_product.getModel(navigationIDs);


    const unbindCurrentPageClicked = $scope.$on('current_page_clicked', function ($event, params) {
        if (initialized) {
            reset();
        }
    });
    $scope.$on('$destroy', unbindCurrentPageClicked);

    $scope.have_matrix_product_data = false;

    $scope.condition_models = {};
    $scope.full_product_choice_list = [];
    $scope.current_choice_list = [];

    $scope.current_site_range_ids = [];

    $scope.have_any_filters = false;
    $scope.filter_summary = [];

    $scope.filter_order = ["solution", "site_range", "style", "colour", "assembly", "parent_category", "alpha_category", "beta_category", "width", "internal", "hinge_hole", "overhang", "hinge_colour", "hettich_colour"];

    $scope.quick_model_ids = ['parent_category', 'alpha_category', 'beta_category'];

    $scope.unit_category_visible_list = [];
    $scope.width_category_visible_list = [];
    $scope.current_product_choices = {}


    function initConditionModels() {

        function initFullProductChoiceList() {
            const fromChoiceChoiceList = $scope.matrix_product_model.choiceList();
            const choiceList = [];
            const parentCategoryID = navigationIDs.parent_category_id;
            const collectionProductModel = $rootScope.factory.collection_product.getModel(navigationIDs);
            let c = 0;
            for (let i = 0; i < fromChoiceChoiceList.length; i++) {
                const fromChoice = fromChoiceChoiceList[i];
                if (parentCategoryID && (!fromChoice.parent_category_ids || !fromChoice.parent_category_ids.includes(parentCategoryID))) {
                    c++;
                    continue;
                }
                const routeChoice = collectionProductModel.choices[fromChoice.id]
                const href = routeChoice ? routeChoice.href : null;
                if (!href) {
                    continue;
                }
                const choice = fromChoice.clone();
                choice.href = href;

                choiceList.push(choice);
            }
            $scope.full_product_choice_list = choiceList;
        }

        function addChoiceList(model, choiceList) {
            model.choices = {};
            model.choice_order = [];
            for (let i = 0; i < choiceList.length; i++) {
                const choice = choiceList[i];
                if (model.choice_order.indexOf(choice.id) === -1) {
                    choice.model_id = model.id;
                    model.choices[choice.id] = choice;
                    model.choice_order.push(choice.id)
                }
            }
        }

        function initRequirementModel(model, includeAny, includeAll, includeOnly, includeExclude, includeNone, hideAny) {
            model.isRequirementModel = true;
            const anyChoice = new ModelChoice({
                id: "any",
                name: "Any"
            });
            const choiceList = [anyChoice];

            if (includeNone) {
                const noneAvailableChoice = new ModelChoice({
                    id: "none_available",
                    name: "Must NOT be available"
                });
                choiceList.push(noneAvailableChoice)
            }

            if (includeAny) {
                const anySelectedChoice = new ModelChoice({
                    id: "any_selected",
                    name: "Must be available in ANY selected",
                    alwaysHidden: hideAny
                });
                choiceList.push(anySelectedChoice)
            }
            if (includeAll) {
                const allSelectedChoice = new ModelChoice({
                    id: "all_selected",
                    name: "Must be available in ALL selected"
                });
                choiceList.push(allSelectedChoice)
            }
            if (includeOnly) {
                const onlySelectedChoice = new ModelChoice({
                    id: "only_selected",
                    name: "ONLY available in any selected"
                });
                choiceList.push(onlySelectedChoice)
            }
            if (includeExclude) {
                const excludeSelectedChoice = new ModelChoice({
                    id: "exclude_selected",
                    name: "NOT available in any selected"
                });
                choiceList.push(excludeSelectedChoice)
            }
            addChoiceList(model, choiceList);
            model.current_value = "any";
        }

        function createSolutionRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "solution_requirement",
                name: "Solution Journey Requirement"
            })
            initRequirementModel(requirementModel, true, true, true, false);

            $scope.condition_models.solution_requirement = requirementModel;
        }


        function createSolutionModel() {

            const contentModel = new FilterConditionModel({
                id: "solution",
                name: "Solution"
            });
            const solutionModel = $rootScope.factory.solution.getModel()
            const choiceList = solutionModel.choiceList();

            for (let i = 0; i < choiceList.length; i++) {
                choiceList[i] = choiceList[i].clone();
            }
            addChoiceList(contentModel, choiceList);
            $scope.condition_models.solution = contentModel

            applySolutionFilter();
            for (let i = 0; i < choiceList.length; i++) {
                const choice = choiceList[i];
                if (choice.hidden) {
                    choiceList.splice(i, 1);
                    i--;
                }
            }
            addChoiceList(contentModel, choiceList);

            const requirementModel = $scope.condition_models.solution_requirement;
            contentModel.paired_model_id = "solution_requirement";
            requirementModel.paired_model_id = "solution";
        }


        function createSiteRangeRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "site_range_requirement",
                name: "Site Range Requirement"
            })
            initRequirementModel(requirementModel, true, true, false, true);

            $scope.condition_models.site_range_requirement = requirementModel;
        }

        function createSiteRangeModel() {

            const contentModel = new FilterConditionModel({
                id: "site_range",
                name: "Range"
            });
            const siteRangeModel = $rootScope.factory.site_range.getModel()
            const fromSiteRangeChoiceList = siteRangeModel.choiceList();
            const choiceList = [];
            for (let i = 0; i < fromSiteRangeChoiceList.length; i++) {
                const fromChoice = fromSiteRangeChoiceList[i];
                choiceList.push({
                    id: fromChoice.id,
                    name: fromChoice.name
                })
            }

            addChoiceList(contentModel, choiceList);
            $scope.condition_models.site_range = contentModel

            applySiteRangeFilter();
            for (let i = 0; i < choiceList.length; i++) {
                const choice = choiceList[i];
                if (choice.hidden) {
                    choiceList.splice(i, 1);
                    i--;
                }
            }
            addChoiceList(contentModel, choiceList);

            const requirementModel = $scope.condition_models.site_range_requirement;
            contentModel.paired_model_id = "site_range_requirement";
            requirementModel.paired_model_id = "site_range";
        }


        function createStyleRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "style_requirement",
                name: "Style Requirement"
            })
            initRequirementModel(requirementModel, true, true, false, true);

            $scope.condition_models.style_requirement = requirementModel;
        }

        function createStyleModel() {

            const contentModel = new FilterConditionModel({
                id: "style",
                name: "Styles"
            });

            const choiceList = [];
            const siteRangeIDs = ["bella"];
            for (let i = 0; i < siteRangeIDs.length; i++) {
                const siteRangeID = siteRangeIDs[i];
                const styleModel = $rootScope.factory.style.getModel({site_range_id: siteRangeID})
                const fromStyleChoiceList = styleModel.choiceList();
                for (let i = 0; i < fromStyleChoiceList.length; i++) {
                    const fromChoice = fromStyleChoiceList[i];
                    choiceList.push({
                        id: siteRangeID + "_" + fromChoice.id,
                        name: fromChoice.name
                    })
                }
            }

            addChoiceList(contentModel, choiceList);
            $scope.condition_models.style = contentModel

            applyStyleFilter();
            for (let i = 0; i < choiceList.length; i++) {
                const choice = choiceList[i];
                if (choice.hidden) {
                    choiceList.splice(i, 1);
                    i--;
                }
            }
            addChoiceList(contentModel, choiceList);

            const requirementModel = $scope.condition_models.style_requirement;
            contentModel.paired_model_id = "style_requirement";
            requirementModel.paired_model_id = "style";
        }


        function createColourRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "colour_requirement",
                name: "Colour Requirement"
            })
            initRequirementModel(requirementModel, true, true, false, true);

            $scope.condition_models.colour_requirement = requirementModel;
        }

        function createColourModel() {

            const contentModel = new FilterConditionModel({
                id: "colour",
                name: "Colours"
            });

            const choiceList = [];
            const siteRangeIDs = $rootScope.service.site_range.getSiteRangeIDs();
            for (let i = 0; i < siteRangeIDs.length; i++) {
                const siteRangeID = siteRangeIDs[i];
                const namePrefix = ["valore", "bella", "zurfiz"].includes(siteRangeID) ? siteHelper.uppercaseFirst(siteRangeID) + " " : "";
                const colourModel = $rootScope.factory.colour.getModel({site_range_id: siteRangeID})
                const fromColourChoiceList = colourModel.choiceList();
                for (let i = 0; i < fromColourChoiceList.length; i++) {
                    const fromChoice = fromColourChoiceList[i];
                    choiceList.push({
                        id: siteRangeID + "_" + fromChoice.id,
                        name: namePrefix + fromChoice.name
                    })
                }
            }

            addChoiceList(contentModel, choiceList);
            $scope.condition_models.colour = contentModel

            applyColourFilter();
            for (let i = 0; i < choiceList.length; i++) {
                const choice = choiceList[i];
                if (choice.hidden) {
                    choiceList.splice(i, 1);
                    i--;
                }
            }
            addChoiceList(contentModel, choiceList);

            const requirementModel = $scope.condition_models.colour_requirement;
            contentModel.paired_model_id = "colour_requirement";
            requirementModel.paired_model_id = "colour";
        }

        function createAssemblyRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "assembly_requirement",
                name: "Assembly Requirement"
            })
            initRequirementModel(requirementModel, true, true, true);

            $scope.condition_models.assembly_requirement = requirementModel;
        }


        function createAssemblyModel() {

            const contentModel = new FilterConditionModel({
                id: "assembly",
                name: "Assembly"
            });
            const assemblyModel = $rootScope.factory.assembly.getModel(navigationIDs)
            const fromAssemblyChoiceList = assemblyModel.choiceList();
            const choiceList = [];
            for (let i = 0; i < fromAssemblyChoiceList.length; i++) {
                const fromChoice = fromAssemblyChoiceList[i];
                choiceList.push({
                    id: fromChoice.id,
                    name: fromChoice.name
                })
            }
            addChoiceList(contentModel, choiceList);
            $scope.condition_models.assembly = contentModel

            applyAssemblyFilter();
            for (let i = 0; i < choiceList.length; i++) {
                const choice = choiceList[i];
                if (choice.hidden) {
                    choiceList.splice(i, 1);
                    i--;
                }
            }
            addChoiceList(contentModel, choiceList);

            const requirementModel = $scope.condition_models.assembly_requirement;
            contentModel.paired_model_id = "assembly_requirement";
            requirementModel.paired_model_id = "assembly";
        }

        function createParentCategoryRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "parent_category_requirement",
                name: "Parent Category Requirement"
            })
            initRequirementModel(requirementModel, true);

            $scope.condition_models.parent_category_requirement = requirementModel;
        }

        function createParentCategoryModel() {

            const contentModel = new FilterConditionModel({
                id: "parent_category",
                name: "Cabinet Type"
            });

            addChoiceList(contentModel, $scope.matrix_product_model.categories.parent);
            $scope.condition_models.parent_category = contentModel

            applyParentCategoryFilter();

            const requirementModel = $scope.condition_models.parent_category_requirement;
            contentModel.paired_model_id = "parent_category_requirement";
            requirementModel.paired_model_id = "parent_category";
        }

        function createAlphaCategoryRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "alpha_category_requirement",
                name: "Category Requirement"
            })
            initRequirementModel(requirementModel, true, true, true, true, false, !!navigationIDs.alpha_category_id);

            $scope.condition_models.alpha_category_requirement = requirementModel;
        }

        function createAlphaCategoryModel() {

            const contentModel = new FilterConditionModel({
                id: "alpha_category",
                name: "Category",
                hideName: !isComponentMatrix,
                hideAny: !isComponentMatrix
            });

            addChoiceList(contentModel, $scope.matrix_product_model.categories.alpha);
            $scope.condition_models.alpha_category = contentModel

            applyAlphaCategoryFilter();

            const requirementModel = $scope.condition_models.alpha_category_requirement;
            contentModel.paired_model_id = "alpha_category_requirement";
            requirementModel.paired_model_id = "alpha_category";
        }

        function createBetaCategoryRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "beta_category_requirement",
                name: "Filter By Requirement"
            })
            initRequirementModel(requirementModel, true);

            $scope.condition_models.beta_category_requirement = requirementModel;
        }

        function createBetaCategoryModel() {

            const contentModel = new FilterConditionModel({
                id: "beta_category",
                name: "Filter By"
            });

            addChoiceList(contentModel, $scope.matrix_product_model.categories.beta);
            $scope.condition_models.beta_category = contentModel

            applyBetaCategoryFilter();

            const requirementModel = $scope.condition_models.beta_category_requirement;
            contentModel.paired_model_id = "beta_category_requirement";
            requirementModel.paired_model_id = "beta_category";
        }

        function createWidthRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "width_requirement",
                name: "Width Requirement"
            })
            initRequirementModel(requirementModel, true);

            $scope.condition_models.width_requirement = requirementModel;
        }

        function createWidthModel() {

            const contentModel = new FilterConditionModel({
                id: "width",
                name: "Width"
            });

            addChoiceList(contentModel, $scope.matrix_product_model.categories.width);
            $scope.condition_models.width = contentModel

            applyWidthFilter();

            const requirementModel = $scope.condition_models.width_requirement;
            contentModel.paired_model_id = "width_requirement";
            requirementModel.paired_model_id = "width";
        }

        function createInternalRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "internal_requirement",
                name: "Internal Requirement"
            })
            initRequirementModel(requirementModel, true, true, false, true, true);

            $scope.condition_models.internal_requirement = requirementModel;
        }

        function createInternalModel() {

            const contentModel = new FilterConditionModel({
                id: "internal",
                name: "Internals"
            });

            addChoiceList(contentModel, $scope.matrix_product_model.categories.internal);
            $scope.condition_models.internal = contentModel

            applyInternalFilter();

            const requirementModel = $scope.condition_models.internal_requirement;
            contentModel.paired_model_id = "internal_requirement";
            requirementModel.paired_model_id = "internal";
        }

        function createHingeHoleRequirementModel() {

            const requirementModel = new FilterConditionModel({
                id: "hinge_hole_requirement",
                name: "Hinge Hole Requirement"
            })
            initRequirementModel(requirementModel, true, true, true, true, true);

            $scope.condition_models.hinge_hole_requirement = requirementModel;
        }

        function createHingeHoleModel() {

            const contentModel = new FilterConditionModel({
                id: "hinge_hole",
                name: "Hinge Holes"
            });

            addChoiceList(contentModel, $scope.matrix_product_model.categories.hinge_hole);
            $scope.condition_models.hinge_hole = contentModel

            applyHingeHoleFilter();

            const requirementModel = $scope.condition_models.hinge_hole_requirement;
            contentModel.paired_model_id = "hinge_hole_requirement";
            requirementModel.paired_model_id = "hinge_hole";
        }

        function createOverhangModel() {

            const contentModel = new FilterConditionModel({
                id: "overhang",
                name: "Overhang"
            });

            const choiceList = [
                {
                    id: "any",
                    name: "Any"
                },
                {
                    id: "overhang_yes",
                    name: "Has overhang option"
                },
                {
                    id: "overhang_no",
                    name: "No overhang option"
                }
            ];

            addChoiceList(contentModel, choiceList);
            contentModel.current_value = "any";
            $scope.condition_models.overhang = contentModel

            applyOverhangFilter();
        }

        function createHingeColourModel() {

            const contentModel = new FilterConditionModel({
                id: "hinge_colour",
                name: "Hinge Colour"
            });

            const choiceList = [
                {
                    id: "any",
                    name: "Any"
                },
                {
                    id: "hinge_colour_yes",
                    name: "Hinge colour required"
                },
                {
                    id: "hinge_colour_no",
                    name: "Hinge colour not required"
                }
            ];

            addChoiceList(contentModel, choiceList);
            contentModel.current_value = "any";
            $scope.condition_models.hinge_colour = contentModel

            applyHingeColourFilter();
        }

        function createHettichColourModel() {

            const contentModel = new FilterConditionModel({
                id: "hettich_colour",
                name: "Drawer Colour"
            });

            const choiceList = [
                {
                    id: "any",
                    name: "Any"
                },
                {
                    id: "hettich_colour_yes",
                    name: "Drawer colour required"
                },
                {
                    id: "hettich_colour_no",
                    name: "Drawer colour not required"
                }
            ];

            addChoiceList(contentModel, choiceList);
            contentModel.current_value = "any";
            $scope.condition_models.hettich_colour = contentModel

            applyHettichColourFilter();
        }

        $scope.condition_models = {};

        initFullProductChoiceList()

        $scope.current_choice_list = $scope.full_product_choice_list.slice()

        for (let i = 0; i < $scope.filter_order.length; i++) {
            const filterID = $scope.filter_order[i];
            switch (filterID) {
                case "solution":
                    createSolutionRequirementModel();
                    createSolutionModel();
                    break;
                case "site_range":
                    createSiteRangeRequirementModel();
                    createSiteRangeModel();
                    break;
                case "style":
                    createStyleRequirementModel();
                    createStyleModel();
                    break;
                case "colour":
                    createColourRequirementModel();
                    createColourModel();
                    break;
                case "assembly":
                    createAssemblyRequirementModel();
                    createAssemblyModel();
                    break;
                case "parent_category":
                    createParentCategoryRequirementModel();
                    createParentCategoryModel();
                    break;
                case "alpha_category":
                    createAlphaCategoryRequirementModel();
                    createAlphaCategoryModel();
                    break;
                case "beta_category":
                    createBetaCategoryRequirementModel();
                    createBetaCategoryModel();
                    break;
                case "width":
                    createWidthRequirementModel();
                    createWidthModel();
                    break;
                case "internal":
                    createInternalRequirementModel();
                    createInternalModel();
                    break;
                case "hinge_hole":
                    createHingeHoleRequirementModel();
                    createHingeHoleModel();
                    break;
                case "overhang":
                    createOverhangModel();
                    break;
                case "hinge_colour":
                    createHingeColourModel();
                    break;
                case "hettich_colour":
                    createHettichColourModel();
                    break;
                default:
                    break;
            }
        }
    }

    function reset() {

        const preselectedValues = {}
        const includeParentCategoryIDs = $scope.matrix_product_model.include_parent_category_ids;
        const includeAlphaCategoryIDs = $scope.matrix_product_model.include_alpha_category_ids;

        const preselectedParentCategoryID = includeParentCategoryIDs && includeParentCategoryIDs.length === 1 ? includeParentCategoryIDs[0] : null;
        if (preselectedParentCategoryID) {
            preselectedValues.parent_category = preselectedParentCategoryID;
        }
        const preselectedAlphaCategoryID = includeAlphaCategoryIDs && includeAlphaCategoryIDs.length === 1 ? includeAlphaCategoryIDs[0] : null;
        if (preselectedAlphaCategoryID) {
            preselectedValues.alpha_category = preselectedAlphaCategoryID;
        }

        for (let modelID in $scope.condition_models) {
            const model = $scope.condition_models[modelID];
            if (model.isRequirementModel) {
                continue;
            }

            model.isPreselected = false;
            const preselectedValue = preselectedValues[modelID];

            for (let choiceID in model.choices) {
                const choice = model.choices[choiceID];
                choice.selected = false;
                if (preselectedValue) {
                    choice.selected = preselectedValue === choiceID;
                    if (choice.selected) {
                        model.isPreselected = true;
                    }
                } else if (!isComponentMatrix && modelID === 'alpha_category') {
                    if (!choice.hidden) {
                        choice.selected = true;
                    }
                }
                if (choice.selected) {
                    break;
                }
            }
        }
        applyCurrentFilters();
        initialized = true;
    }

    $scope.handleClickFilterCheckbox = function (choice) {

        applyCurrentFilters();
    }

    function filterUnselectedChoiceList(contentModel, requirementModel) {

        const requireSelected = ["any_selected", "all_selected", "only_selected"].includes(requirementModel.current_value);
        const contentChoiceList = contentModel.choiceList();

        const choiceList = [];
        for (let i = 0; i < contentChoiceList.length; i++) {
            const choice = contentChoiceList[i];
            if (!choice.hidden) {
                if (!requireSelected || choice.selected) {
                    choiceList.push(choice);
                }
            }
        }
        return choiceList;
    }

    function applyRequirementFilter(contentModel, requirementModel, determineValidIDs, isExcludeIDs, minimumVisibleContentCount) {


        const productChoiceList = $scope.current_choice_list;
        let allValid = false;
        const validIDs = [];
        for (let i = 0; i < productChoiceList.length; i++) {
            const productChoice = productChoiceList[i];
            const productValidIDs = determineValidIDs(productChoice);

            if (!productValidIDs) {
                if (isExcludeIDs) {
                    continue
                }
                allValid = true;
                break;
            }
            for (let j = 0; j < productValidIDs.length; j++) {
                const choiceID = productValidIDs[j];
                if (validIDs.indexOf(choiceID) === -1) {
                    validIDs.push(choiceID);
                }
            }
        }

        const contentChoiceList = contentModel.choiceList();
        const selectedChoiceList = [];
        let visibleContentCount = 0;
        for (let i = 0; i < contentChoiceList.length; i++) {
            const choice = contentChoiceList[i];
            const valid = (allValid || validIDs.indexOf(choice.id) !== -1) && !choice.hide_me;
            if (!valid) {
                choice.hidden = true;
                choice.selected = false;
            } else {
                choice.hidden = false;
                visibleContentCount++;
                if (choice.selected) {
                    selectedChoiceList.push(choice);
                }
            }
        }
        contentModel.hidden = !visibleContentCount || (minimumVisibleContentCount && visibleContentCount < minimumVisibleContentCount) || contentChoiceList.length < 2 || !!contentModel.isPreselected;
        contentModel.visibleContentCount = visibleContentCount;

        const anySelectedChoice = requirementModel.choices.any_selected;
        const allSelectedChoice = requirementModel.choices.all_selected;
        const onlySelectedChoice = requirementModel.choices.only_selected;
        const excludeSelectedChoice = requirementModel.choices.exclude_selected;

        if (!selectedChoiceList.length) {
            if (anySelectedChoice) {
                anySelectedChoice.hidden = true;
            }
            if (allSelectedChoice) {
                allSelectedChoice.hidden = true;
            }
            if (onlySelectedChoice) {
                onlySelectedChoice.hidden = true;
            }
            if (excludeSelectedChoice) {
                excludeSelectedChoice.hidden = true;
            }
            if (requirementModel.current_value !== "none_available") {
                requirementModel.current_value = "any";
            }
        } else {
            if (anySelectedChoice) {
                anySelectedChoice.hidden = !!(visibleContentCount < 2 && allSelectedChoice);
            }
            if (allSelectedChoice) {
                allSelectedChoice.hidden = false;
            }
            if (onlySelectedChoice) {
                onlySelectedChoice.hidden = false;
            }
            if (excludeSelectedChoice) {
                excludeSelectedChoice.hidden = false;
            }
            if (requirementModel.current_value === "any") {
                if (anySelectedChoice && !anySelectedChoice.hidden) {
                    requirementModel.current_value = "any_selected";
                } else if (anySelectedChoice && !anySelectedChoice.hidden) {
                    requirementModel.current_value = "all_selected";
                } else if (onlySelectedChoice && !onlySelectedChoice.hidden) {
                    requirementModel.current_value = "only_selected";
                } else if (excludeSelectedChoice && !excludeSelectedChoice.hidden) {
                    requirementModel.current_value = "exclude_selected";
                } else {
                    requirementModel.current_value = "any_selected";
                }
            }
        }
        if (requirementModel.current_value === "any") {
            contentModel.quick_value = "any";
        } else if (requirementModel.current_value === "any_selected" && selectedChoiceList.length === 1) {
            contentModel.quick_value = selectedChoiceList[0].id;
        } else {
            contentModel.quick_value = "custom"
        }

        const filteredProductChoiceList = [];
        for (let i = 0; i < productChoiceList.length; i++) {
            const productChoice = productChoiceList[i];
            let valid = false;
            let haveAny = false;
            let haveAll = true;
            let haveOther = false;
            const productValidIDs = determineValidIDs(productChoice);
            if (requirementModel.current_value === "any") {
                if(!(anySelectedChoice?.alwaysHidden ?? false)) {
                    valid = true;
                }
            } else {
                for (let j = 0; j < contentChoiceList.length; j++) {
                    const contentChoice = contentChoiceList[j];
                    let isValidContent = !productValidIDs;
                    if (!isValidContent) {
                        isValidContent = productValidIDs.indexOf(contentChoice.id) !== -1;
                        if (isExcludeIDs) {
                            isValidContent = !isValidContent;
                        }
                    }
                    if (contentChoice.selected) {
                        if (isValidContent) {
                            haveAny = true;
                        } else {
                            haveAll = false;
                        }
                    } else {
                        if (isValidContent && !contentChoice.hide_me) {
                            haveOther = true;
                        }
                    }
                }
                if (requirementModel.current_value === "none_available") {
                    valid = !haveAny && !haveOther;
                } else if (requirementModel.current_value === "any_selected") {
                    valid = haveAny;
                } else if (requirementModel.current_value === "all_selected") {
                    valid = haveAll;
                } else if (requirementModel.current_value === "only_selected") {
                    valid = haveAny && !haveOther;
                } else if (requirementModel.current_value === "exclude_selected") {
                    valid = !haveAny;
                }
            }
            if (valid) {
                filteredProductChoiceList.push(productChoice);
            }
        }
        contentModel.remaining_product_count = filteredProductChoiceList.length
        $scope.current_choice_list = filteredProductChoiceList;
    }

    function applyBasicFilter(contentModel, determineValidID, minimumValidIDs) {
        const productChoiceList = $scope.current_choice_list;
        const validIDs = ["any"];
        minimumValidIDs = minimumValidIDs || minimumValidIDs === 0 ? minimumValidIDs : 3;
        for (let i = 0; i < productChoiceList.length; i++) {
            const productChoice = productChoiceList[i];
            const productValidID = determineValidID(productChoice);
            if (productValidID && validIDs.indexOf(productValidID) === -1) {
                validIDs.push(productValidID)
            }
        }

        const contentChoiceList = contentModel.choiceList();
        let visibleContentCount = 0;
        for (let i = 0; i < contentChoiceList.length; i++) {
            const choice = contentChoiceList[i];
            const valid = validIDs.indexOf(choice.id) !== -1;
            if (!valid) {
                choice.hidden = true;
                choice.selected = false;
            } else {
                choice.hidden = false;
                visibleContentCount++;
            }
        }
        contentModel.hidden = visibleContentCount < minimumValidIDs;

        if (contentModel.hidden) {
            contentModel.current_value = "any";
        }
        contentModel.quick_value = contentModel.current_value;

        const filteredProductChoiceList = [];
        for (let i = 0; i < productChoiceList.length; i++) {
            const productChoice = productChoiceList[i];
            let valid = false;
            if (contentModel.current_value === "any") {
                valid = true;
            } else {
                const productValidID = determineValidID(productChoice);
                valid = productValidID === contentModel.current_value;
            }
            if (valid) {
                filteredProductChoiceList.push(productChoice);
            }
        }
        contentModel.remaining_product_count = filteredProductChoiceList.length
        $scope.current_choice_list = filteredProductChoiceList;
    }

    function applySolutionFilter() {
        const contentModel = $scope.condition_models.solution;
        const requirementModel = $scope.condition_models.solution_requirement;

        const determineValidIDs = function (productChoice) {
            return productChoice.solution_ids ? productChoice.solution_ids : [];
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs);

    }


    function applySiteRangeFilter() {

        const contentModel = $scope.condition_models.site_range;
        const requirementModel = $scope.condition_models.site_range_requirement;

        const determineValidIDs = function (productChoice) {
            if (!productChoice.site_range) {
                return null;
            }
            const validIDs = [];
            for (let validID in productChoice.site_range) {
                validIDs.push(validID)
            }
            return validIDs;
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs);

        let currentSiteRangeIDs = [];

        const productChoiceList = $scope.current_choice_list;
        for (let i = 0; i < productChoiceList.length; i++) {
            const productChoice = productChoiceList[i];
            if (!productChoice.site_range) {
                currentSiteRangeIDs = null;
                break;
            }
            for (let validID in productChoice.site_range) {
                if (currentSiteRangeIDs.indexOf(validID) === -1) {
                    currentSiteRangeIDs.push(validID)
                }
            }
        }
        if (currentSiteRangeIDs === null) {
            currentSiteRangeIDs = contentModel.choice_order.slice();
        }

        if (requirementModel.current_value !== "any") {
            for (let i = 0; i < currentSiteRangeIDs.length; i++) {
                const siteRangeID = currentSiteRangeIDs[i];
                const contentChoice = contentModel.choices[siteRangeID];
                if (!contentChoice || !contentChoice.selected) {
                    currentSiteRangeIDs.splice(i, 1);
                    i--;
                }
            }
        }

        $scope.current_site_range_ids = currentSiteRangeIDs;

    }


    function applyStyleFilter() {

        const contentModel = $scope.condition_models.style;
        const requirementModel = $scope.condition_models.style_requirement;

        const determineValidIDs = function (productChoice) {
            if (!productChoice.site_range) {
                return null;
            }
            const validIDs = [];
            for (let i = 0; i < $scope.current_site_range_ids.length; i++) {
                const siteRangeID = $scope.current_site_range_ids[i];
                const siteRange = productChoice.site_range[siteRangeID];
                if (siteRange && siteRange.style_exceptions) {
                    for (let j = 0; j < siteRange.style_exceptions.length; j++) {
                        const styleID = siteRangeID + "_" + siteRange.style_exceptions[j];
                        if (validIDs.indexOf(styleID) === -1) {
                            validIDs.push(styleID)
                        }
                    }
                }
            }
            return validIDs;
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs, true);
    }


    function applyColourFilter() {

        const contentModel = $scope.condition_models.colour;
        const requirementModel = $scope.condition_models.colour_requirement;

        const determineValidIDs = function (productChoice) {
            if (!productChoice.site_range) {
                return null;
            }
            const validIDs = [];
            for (let i = 0; i < $scope.current_site_range_ids.length; i++) {
                const siteRangeID = $scope.current_site_range_ids[i];
                const siteRange = productChoice.site_range[siteRangeID];
                if (siteRange && siteRange.colour_exceptions) {
                    for (let j = 0; j < siteRange.colour_exceptions.length; j++) {
                        const colourID = siteRangeID + "_" + siteRange.colour_exceptions[j];
                        if (validIDs.indexOf(colourID) === -1) {
                            validIDs.push(colourID)
                        }
                    }
                }
            }
            return validIDs;
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs, true);
    }

    function applyAssemblyFilter() {

        const contentModel = $scope.condition_models.assembly;
        const requirementModel = $scope.condition_models.assembly_requirement;

        const determineValidIDs = function (productChoice) {
            return productChoice.assembly_ids ? productChoice.assembly_ids : [];
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs);

    }


    function applyParentCategoryFilter() {

        const contentModel = $scope.condition_models.parent_category;
        const requirementModel = $scope.condition_models.parent_category_requirement;

        const determineValidIDs = function (productChoice) {
            return productChoice.parent_category_ids;
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs);
    }


    function applyAlphaCategoryFilter() {

        const contentModel = $scope.condition_models.alpha_category;
        const requirementModel = $scope.condition_models.alpha_category_requirement;

        const determineValidIDs = function (productChoice) {
            return productChoice.alpha_category_ids;
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs);
    }


    function applyBetaCategoryFilter() {

        const contentModel = $scope.condition_models.beta_category;
        const requirementModel = $scope.condition_models.beta_category_requirement;

        const determineValidIDs = function (productChoice) {
            return productChoice.beta_category_ids;
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs, null, 2);
    }


    function applyWidthFilter() {

        const contentModel = $scope.condition_models.width;
        const requirementModel = $scope.condition_models.width_requirement;

        const determineValidIDs = function (productChoice) {
            return [productChoice.width_category_id];
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs);
    }


    function applyInternalFilter() {

        const contentModel = $scope.condition_models.internal;
        const requirementModel = $scope.condition_models.internal_requirement;

        const determineValidIDs = function (productChoice) {
            return productChoice.internalIDs ? productChoice.internalIDs : [];
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs);
    }


    function applyHingeHoleFilter() {

        const contentModel = $scope.condition_models.hinge_hole;
        const requirementModel = $scope.condition_models.hinge_hole_requirement;

        const determineValidIDs = function (productChoice) {
            return productChoice.hingeHoleIDs ? productChoice.hingeHoleIDs : [];
        }

        applyRequirementFilter(contentModel, requirementModel, determineValidIDs);
    }

    function applyOverhangFilter() {

        const contentModel = $scope.condition_models.overhang;

        const determineValidID = function (productChoice) {
            return productChoice.overhang ? "overhang_yes" : "overhang_no";
        }

        applyBasicFilter(contentModel, determineValidID);
    }

    function applyHingeColourFilter() {

        const contentModel = $scope.condition_models.hinge_colour;

        const determineValidID = function (productChoice) {
            return productChoice.requires_hinge_colour ? "hinge_colour_yes" : "hinge_colour_no";
        }

        applyBasicFilter(contentModel, determineValidID);
    }

    function applyHettichColourFilter() {

        const contentModel = $scope.condition_models.hettich_colour;

        const determineValidID = function (productChoice) {
            return productChoice.requires_hettich_colour ? "hettich_colour_yes" : "hettich_colour_no";
        }

        applyBasicFilter(contentModel, determineValidID);
    }

    function applyCurrentFilters() {
        $scope.current_choice_list = $scope.full_product_choice_list.slice();

        for (let i = 0; i < $scope.filter_order.length; i++) {
            const filterID = $scope.filter_order[i];
            switch (filterID) {
                case "solution":
                    applySolutionFilter();
                    break;
                case "site_range":
                    applySiteRangeFilter();
                    break;
                case "style":
                    applyStyleFilter();
                    break;
                case "colour":
                    applyColourFilter();
                    break;
                case "assembly":
                    applyAssemblyFilter();
                    break;
                case "parent_category":
                    applyParentCategoryFilter();
                    break;
                case "alpha_category":
                    applyAlphaCategoryFilter();
                    break;
                case "beta_category":
                    applyBetaCategoryFilter();
                    break;
                case "width":
                    applyWidthFilter();
                    break;
                case "internal":
                    applyInternalFilter();
                    break;
                case "hinge_hole":
                    applyHingeHoleFilter();
                    break;
                case "overhang":
                    applyOverhangFilter();
                    break;
                case "hinge_colour":
                    applyHingeColourFilter();
                    break;
                case "hettich_colour":
                    applyHettichColourFilter();
                    break;
                default:
                    break;
            }
        }

        updateCurrentProductChoices();
        updateWidthCategoryVisibleList();
        updateUnitCategoryVisibleList();
        updateFilterInfo();
    }


    $scope.matrix_product_model.requirePrepared(function () {
        $scope.have_matrix_product_data = true;
        initConditionModels();
        reset();
    })

    $scope.allFilterToggle = function () {

        const $itemFilters = $("#all-filters").find(".collapse");
        $itemFilters.collapse("hide")
    }

    $scope.itemFilterToggle = function (toggleID) {

        const $itemFilters = $("#all-filters").find(".collapse");
        $itemFilters.each(function () {
            const $altItemFilter = $(this);
            if ($altItemFilter.attr("id") !== toggleID) {
                $altItemFilter.collapse("hide")
            }
        })
    }


    function updateCurrentProductChoices() {

        $scope.current_product_choices = {};

        for (let i = 0; i < $scope.current_choice_list.length; i++) {
            const product = $scope.current_choice_list[i];

            $scope.current_product_choices[product.id] = product
        }
    }


    function updateWidthCategoryVisibleList() {
        const visibleWidths = {};
        for (let i = 0; i < $scope.current_choice_list.length; i++) {
            const productChoice = $scope.current_choice_list[i];
            if (visibleWidths[productChoice.width_category_id]) {
                continue
            }
            const widthCategoryChoice = $scope.condition_models.width.choices[productChoice.width_category_id];
            if (widthCategoryChoice) {
                visibleWidths[productChoice.width_category_id] = true;
            }

        }
        $scope.width_category_visible_list.length = 0;
        const widthChoiceList = $scope.condition_models.width.choiceList()
        for (let i = 0; i < widthChoiceList.length; i++) {
            const widthChoice = widthChoiceList[i];
            if (widthChoice.hidden || !visibleWidths[widthChoice.id]) {
                continue;
            }
            $scope.width_category_visible_list.push(widthChoice)
        }
    }

    function updateUnitCategoryVisibleList() {
        const visibleChoiceList = [];
        for (let i = 0; i < $scope.matrix_product_model.categories.unit.length; i++) {
            const unitCategory = $scope.matrix_product_model.categories.unit[i];
            if (!unitCategory) {
                continue;
            }
            let hidden = true;
            for (let widthCategoryID in unitCategory.width_category_product_ids) {
                const productIDs = unitCategory.width_category_product_ids[widthCategoryID]
                const widthChoice = $scope.condition_models.width.choices[widthCategoryID];
                if (widthChoice) {
                    for (let j = 0; j < productIDs.length; j++) {
                        const product = $scope.current_product_choices[productIDs[j]];
                        if (product) {
                            hidden = false;
                            break;
                        }
                    }
                }
                if (!hidden) {
                    break;
                }
            }
            unitCategory.hidden = hidden;
            if (!hidden) {
                visibleChoiceList.push(unitCategory)
            }
        }
        $scope.unit_category_visible_list.visible_choice_list = visibleChoiceList;
    }


    $scope.fadeQuickChange = function (filterID, resetFilterIDs) {
        const fadeOverlay = document.getElementById("fade-overlay")
        fadeOverlay.classList.add("apply-fade");
        setTimeout(function () {
            $scope.onQuickChange(filterID, resetFilterIDs);
            $scope.$apply();

            setTimeout(function () {
                fadeOverlay.classList.remove("apply-fade");
            }, 300);
        }, 200)
    }

    $scope.onQuickChange = function (filterID, resetFilterIDs) {

        const $allFilters = $("#all-filters")
        const conditionModel = $scope.condition_models[filterID];
        const quickValue = conditionModel.quick_value
        $allFilters.collapse("hide");
        const conditionChoiceList = conditionModel.choiceList();
        for (let i = 0; i < conditionChoiceList.length; i++) {
            const choice = conditionChoiceList[i];
            choice.selected = choice.id === quickValue;
        }
        if (quickValue === "any") {
            const requirementModel = conditionModel.paired_model_id ? $scope.condition_models[conditionModel.paired_model_id] : null;
            if (requirementModel) {
                requirementModel.current_value = "any";
            } else {
                conditionModel.current_value = "any";
            }
        }
        if (resetFilterIDs) {
            resetFilters(resetFilterIDs);
        }
        applyCurrentFilters();
    }


    $scope.fadeHandleClickFilterRadio = function (filterID) {
        const fadeOverlay = document.getElementById("fade-overlay")
        fadeOverlay.classList.add("apply-fade");
        setTimeout(function () {
            $scope.handleClickFilterRadio(filterID);
            $scope.$apply();

            setTimeout(function () {
                fadeOverlay.classList.remove("apply-fade");
            }, 300);
        }, 200)
    }

    $scope.handleClickFilterRadio = function (choice) {

        if (choice.id === "any" || choice.id === "none_available") {
            const model = choice.model_id ? $scope.condition_models[choice.model_id] : null;
            if (model) {
                const pairedModel = model.paired_model_id ? $scope.condition_models[model.paired_model_id] : null;
                if (pairedModel) {
                    const pairedChoiceList = pairedModel.choiceList();
                    for (let i = 0; i < pairedChoiceList.length; i++) {
                        const pairedChoice = pairedChoiceList[i];
                        pairedChoice.selected = false;
                    }
                }
            }
        }
        applyCurrentFilters();
    }

    function resetFilters(filterIDs, apply) {
        filterIDs = Array.isArray(filterIDs) ? filterIDs : [filterIDs];
        for (let i = 0; i < filterIDs.length; i++) {
            const filterID = filterIDs[i];
            const conditionModel = $scope.condition_models[filterID];
            if (conditionModel) {
                const conditionChoiceList = conditionModel.choiceList();
                for (let j = 0; j < conditionChoiceList.length; j++) {
                    const choice = conditionChoiceList[j];
                    choice.selected = false;
                }
            }
        }
        if (apply) {
            applyCurrentFilters();
        }
    }

    $scope.onQuickCustom = function (filterID) {
        const $allFilters = $("#all-filters")
        applyCurrentFilters();
        const $itemFilters = $allFilters.find(".collapse");
        const $customFilterBtn = $allFilters.find("#condition-filter-" + filterID + "-btn")
        if (!$customFilterBtn.hasClass("collapsed")) {
            $itemFilters.collapse("hide");
            $allFilters.collapse("hide")
        } else {
            const $customFilter = $itemFilters.filter("#condition-filter-" + filterID)
            $itemFilters.collapse("hide");
            $allFilters.collapse("show");
            $customFilter.collapse("show");
            setTimeout(function () {
                $customFilter.collapse("show");
            }, 400)
        }
    }

    function updateFilterInfo() {
        const summary = [];
        let haveAnyFilters = false;
        for (let i = 0; i < $scope.filter_order.length; i++) {
            const filterID = $scope.filter_order[i];
            const conditionModel = $scope.condition_models[filterID];
            if (!conditionModel) {
                continue;
            }

            conditionModel.isFiltered = isItemFiltered(filterID);
            conditionModel.filter_text = itemFilterText(filterID);

            if (!conditionModel.isFiltered) {
                continue;
            }
            haveAnyFilters = true;

            const text = conditionModel.filter_text;
            if (!text) {
                continue;
            }
            summary.push({
                name: conditionModel.name,
                text: text
            })
        }
        $scope.have_any_filters = haveAnyFilters;
        $scope.filter_summary = summary;
    }

    function isItemFiltered(filterID) {
        const conditionModel = $scope.condition_models[filterID];
        if (conditionModel && !conditionModel.hidden) {
            const pairedModel = conditionModel.paired_model_id ? $scope.condition_models[conditionModel.paired_model_id] : null;
            if ((pairedModel && pairedModel.current_value !== "any") || (!pairedModel && conditionModel.current_value !== "any")) {
                return true;
            }
        }
        return false;
    }

    function itemFilterText(filterID) {
        const conditionModel = $scope.condition_models[filterID];
        if (!conditionModel) {
            return "";
        }
        const pairedModel = conditionModel.paired_model_id ? $scope.condition_models[conditionModel.paired_model_id] : null;
        if (pairedModel) {
            const pairedChoice = pairedModel.choices[pairedModel.current_value];
            if (!pairedChoice) {
                return ""
            }
            if (pairedChoice.id === "any" || pairedChoice.id === "none_available") {
                return pairedChoice.name;
            }
            const selectedChoiceList = [];
            const choiceList = conditionModel.choiceList();
            for (let i = 0; i < choiceList.length; i++) {
                const choice = choiceList[i];
                if (choice.selected) {
                    selectedChoiceList.push(choice);
                }
            }
            if (!selectedChoiceList.length) {
                return "";
            }
            let nameString = "";
            for (let i = 0; i < selectedChoiceList.length; i++) {
                const choice = selectedChoiceList[i];
                if (i !== 0) {
                    if (i === selectedChoiceList.length - 1) {
                        nameString += pairedChoice.id === "all_selected" ? " and " : " or ";
                    } else {
                        nameString += ", ";
                    }
                }
                nameString += choice.name;
            }
            let prefix = "";
            if (selectedChoiceList.length === 1) {
                if (pairedChoice.id === "any_selected" || pairedChoice.id === "all_selected") {
                    prefix = "Must be available in"
                }
            }
            if (!prefix) {
                switch (pairedChoice.id) {
                    case "any_selected":
                        prefix = "Must be available in any of"
                        break;
                    case "all_selected":
                        prefix = "Must be available in all of"
                        break;
                    case "only_selected":
                        prefix = "Must only be available in"
                        break;
                    case "exclude_selected":
                        prefix = "Must not be available in"
                        break;
                    default:
                        prefix = pairedChoice.name
                        break;
                }
            }
            return prefix + ": " + nameString;
        } else {
            const choice = conditionModel.choices[conditionModel.current_value];
            return choice ? choice.name : "";
        }
    }

    $scope.windowHeight = function () {
        return window.innerHeight;
    }

    $scope.exportExcel = function () {

        const date = new Date();
        const datString =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2)

        const nameValues = [
            navigationIDs.component_id,
            datString
        ]
        for (let i = 0; i < $scope.filter_order.length; i++) {
            const filterID = $scope.filter_order[i];
            const conditionModel = $scope.condition_models[filterID];
            if (!conditionModel) {
                continue;
            }

            conditionModel.isFiltered = isItemFiltered(filterID);

            if (!isItemFiltered(filterID)) {
                continue;
            }

            let requirementID = null;

            const pairedModel = conditionModel.paired_model_id ? $scope.condition_models[conditionModel.paired_model_id] : null;
            if (pairedModel) {
                const pairedChoice = pairedModel.choices[pairedModel.current_value];
                if (!pairedChoice) {
                    continue;
                }
                let nameString = "";
                if (pairedChoice.id === "any") {
                    requirementID = "any";
                } else if (pairedChoice.id === "none_available") {
                    requirementID = "not-in-any";
                } else {
                    const selectedChoiceList = [];
                    const choiceList = conditionModel.choiceList();
                    for (let i = 0; i < choiceList.length; i++) {
                        const choice = choiceList[i];
                        if (choice.selected) {
                            selectedChoiceList.push(choice);
                        }
                    }
                    if (!selectedChoiceList.length) {
                        continue;
                    }
                    for (let i = 0; i < selectedChoiceList.length; i++) {
                        const choice = selectedChoiceList[i];
                        if (i !== 0) {
                            nameString += "-";
                        }
                        nameString += choice.name;
                    }
                    if (selectedChoiceList.length === 1) {
                        if (pairedChoice.id === "any_selected" || pairedChoice.id === "all_selected") {
                            requirementID = "in"
                        }
                    }
                    if (!requirementID) {
                        switch (pairedChoice.id) {
                            case "any_selected":
                                requirementID = "in-any"
                                break;
                            case "all_selected":
                                requirementID = "in-all"
                                break;
                            case "only_selected":
                                requirementID = "only-in"
                                break;
                            case "exclude_selected":
                                requirementID = "not-in"
                                break;
                            default:
                                break;
                        }
                    }
                }
                if (!requirementID) {
                    continue
                }

                let value = filterID + "-" + requirementID;
                if (nameString) {
                    value += "-" + nameString;
                }
                nameValues.push(value)

            } else {
                const choice = conditionModel.choices[conditionModel.current_value];
                nameValues.push(filterID + "-" + choice.name)
            }
        }
        let fileName = "";
        for (let i = 0; i < nameValues.length; i++) {
            let nameValue = nameValues[i];
            nameValue = nameValue.split("_").join("-").split(" ").join("-").toLowerCase();
            nameValue = nameValue.replace(/[^0-9a-z\-]+/gi, "");
            if (fileName) {
                fileName += "--"
            }
            fileName += nameValue
        }

        const tableID = "solution-table";
        const table = document.getElementById(tableID);


        $rootScope.site_helper.exportExcelTable(table, fileName, {max_width: 50, break_size: true});
    }

    $scope.popoverText = function (product) {

        return "<h6 class='text-center'>" + product.name + "</h6><p class='smallest text-center'>" + product.readable_description + "</p>"
    }

}])